export default (num, float) => {
  const floating = float || 2;
  return parseFloat(num, 10).toFixed(floating);
};
